// Quick-Actions — die 7 V1-Schnell-Aufrufe als Glass-Pill-Row.
// Jeder Button triggert in Batch 3E den jeweiligen Agent über runEve().

import { getAgentTrigger } from '@/agents/agent-trigger';
import type { AgentKey } from '@/types/eve-profile';

interface QuickAction {
  /** V1-Agent-Key (matched mit `agentKey` in services/agent-trigger.ts). */
  agentKey: AgentKey;
  emoji: string;
  label: string;
}

const ACTIONS: ReadonlyArray<QuickAction> = [
  { agentKey: 'lagebild', emoji: '📊', label: 'Gesamtübersicht' },
  { agentKey: 'morgenbriefing', emoji: '🌅', label: 'Morgenbriefing' },
  { agentKey: 'marktupdate', emoji: '📈', label: 'Marktupdate' },
  { agentKey: 'moneyflow', emoji: '🌊', label: 'Money Flow' },
  { agentKey: 'breaking', emoji: '🚨', label: 'Breaking' },
  { agentKey: 'wochenendrückblick', emoji: '📅', label: 'Wochenrückblick' },
  { agentKey: 'marktupdate', emoji: '🌐', label: 'Makro' }, // TODO Phase 4: eigener `makro` AgentKey
];

interface QuickActionsProps {
  /** Wenn gesetzt, wird der Klick mit dem agentKey + Trigger-Text durchgereicht. */
  onTrigger?: (agentKey: AgentKey, triggerText: string) => void | Promise<void>;
}

export function QuickActions({ onTrigger }: QuickActionsProps) {
  const handleClick = (action: QuickAction) => {
    const triggerText = getAgentTrigger(action.agentKey);
    if (onTrigger) {
      void onTrigger(action.agentKey, triggerText);
    } else {
      // eslint-disable-next-line no-console
      console.log('[QuickActions] trigger (placeholder):', action.agentKey, triggerText);
    }
  };

  return (
    <div className="w-full max-w-3xl">
      <div className="flex flex-wrap justify-center gap-1.5 text-xs">
        {ACTIONS.map((action) => (
          <button
            key={action.label}
            type="button"
            onClick={() => handleClick(action)}
            className="glass rounded-full px-3 py-1.5 text-neutral-200 transition hover:bg-white/[0.06] hover:text-white"
          >
            <span aria-hidden className="mr-1">
              {action.emoji}
            </span>
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
}
